import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { BaseTemplate } from './BaseTemplate.js';
import $ from 'jquery';
import FontAwesome from 'react-fontawesome';
import { NavLink  } from 'react-router-dom';

export class Devices extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { url: 'https://sparkjvm.com/cloud/json', api: 'GetDevices', devices: '' };
  }

  componentDidMount() {
    this.getDevices();
    this.test();
  }

  test() {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'GetUserInfo',
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res, status, jqXHR) => {
        if (res) {
          let dashboardGraphs = [];
          if (res.Extra) {
            dashboardGraphs = JSON.parse(atob(res.Extra));
          }
          console.log(res);
          console.log(dashboardGraphs);
        }
      },
      error: (httpReq, status, exception) => {
        this.setState({ error: 1 });
      },
    });
  }

  renderDevices() {
    if (this.state.devices) {
      const listDevices = this.state.devices.map((device) => {
        return(
          <NavLink key={ device.id } to={ '/devices/device-' + device.id } className="devices__el">
            <div className="devices__el__content">
              <FontAwesome className="" name='cube' />
              <span className="devices__el__content__name">{ device.Description }</span>
              <span className="devices__el__content__status">Stato: { device.Status }</span>
              <span className="devices__el__content__serial">S/N: { device.SerialNumber }</span>
            </div>
          </NavLink>
        );
      });
      return(
        <div className="devices">{ listDevices }</div>
      )
    }
    return '';
  }

  getDevices() {
    $.ajax({
      method: 'POST',
      url: this.state.url,
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: this.state.api
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Devices) {
          this.setState({ devices: res.Devices });
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  render() {
    return (
      <BaseTemplate>
        <h1>Dispositivi</h1>
        { this.renderDevices() }
      </BaseTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Devices.js